import styled from 'styled-components';
import {TscThemeName, TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import {StyledAnchor} from '../util/StyledElements';
import separatorSVG from '../../static/svg/mediaLocationSeparator.svg';

export const MediaDetailsLink = styled(StyledAnchor)<{theme: TscThemeNames}>`
   font-size: .875rem;
   font-weight: ${cssConstants.semiBoldWeight};
   text-decoration: underline;
   color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.text.lightMedium : TscStyles.color.text.medium};
   cursor: pointer;
   padding: 0.25rem;
`;

export const MediaDetailsSpan = styled.span<{theme: TscThemeNames}>`
   font-size: .875rem;
   font-weight: ${cssConstants.semiBoldWeight};
   color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.text.light : TscStyles.color.text.mediumDark};
   padding: 0.25rem;
`;

export const MediaLocationContainer = styled.div`
   padding-top: .25rem;
   padding-bottom: .25rem;
   display: flex;
   align-items: center;
   overflow: hidden;
   white-space: nowrap;
`;

export const MediaLocationLink = styled(MediaDetailsLink)`
   padding-left: 0;
   padding-right: 0;
`;

export const MediaLocationSeparator = styled(separatorSVG)<{theme: TscThemeNames}>`
   padding-left: .25rem;
   padding-right: .25rem;
   fill: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.light : TscStyles.color.text.medium};
`;
